<template>
  <section class="box">
    <div class="left_half" :style="datas[name][part]['leftHalfCss']?datas[name][part]['leftHalfCss']:{}">
      <div class="title">
        <h4>{{datas[name][part].title}}</h4>
      </div>
      <div class="text_bewrite2">
        <p>{{datas[name][part].content}}</p>
      </div>
      <div class="btn_warp2">
        <div class="button" @click="go(datas[name][part].url)">
          {{datas[name][part].bool?'进入测试':'进入测验'}}
        </div>
      </div>
    </div>
    <div class="right_half" >
      <img :style="{marginLeft:datas[name][part].right?'180px':''}" :src="`/imgs/careerEvaluation/${datas[name][part].imgName}`"
          alt=""
      />
    </div>
  </section>
</template>

<script>
  export default {
    name: "home",
    data(){
      return{
        name:this.$route.query.name,
        part:this.$route.query.part,
        datas:{
          rgtx:{
            main:{
              title:'人格特性',
              url:{ path:'/careerevalution/guide',query: { name:'rgtx',part:'rgtx11'}},
              imgName:'renge_danao.png',
              content:'人格是个体在一定的遗传素质基础上、在适应环境的过程中所形成的独特行为或内在的行为倾向性。通过人格测试可以让你了解到自己与他人相区别的独特而稳定的思维方式和行为风格。',
              leftHalfCss:{width:'450px'},
              bool:true
            }
          },
          znsp:{
            main:{
              title:'智能水平',
              url:{ path:'/careerevalution/home',query: { name:'znsp',part:'znsp11'}},
              imgName:'zhineng_bg.png',
              content:'智能是在特定的文化背景或社会环境中，人们解决问题或者制造产品的能力，除语言和逻辑数学智能外，还有空间、身体运动、人际、自知、自然和音乐智能。个体的智能并非均衡发展，了解优势智能有助于获得更好的发展。',
              bool:true
            },
            znsp11:{
              title:'语言能力',
              url:{ path:'/careerevalution/guide',query: { name:'znsp',part:'znsp11'}},
              imgName:'yuyan_danao.png',
              content:'语言能力包括辨别词语、理解语句、理顺语序、准确表达等。语言能力强有利于你的写作、表达和人际交流。',
            },
            znsp12:{
              title:'语言能力',
              url:{ path:'/careerevalution/guide',query: { name:'znsp',part:'znsp12'}},
              imgName:'yuyan_danao2.png',
              content:'语言能力包括辨别词语、理解语句、理顺语序、准确表达等。语言能力强有利于你的写作、表达和人际交流。',
            },
            znsp21:{
              title:'自然能力',
              url:{ path:'/careerevalution/guide',query: { name:'znsp',part:'znsp21'}},
              imgName:'/ziran_danao.png',
              content:'自然能力指认识、感知自然事物的能力，包括识别事物关系和根据细节差异对事物进行分类的能力。',
            },
            znsp22:{
              title:'自然能力',
              url:{ path:'/careerevalution/guide',query: { name:'znsp',part:'znsp22'}},
              imgName:'ziran_danao2.png',
              content:'自然能力指认识、感知自然事物的能力，包括识别事物关系和根据细节差异对事物进行分类的能力。',
            },
            znsp31:{
              title:'空间-视觉能力',
              url:{ path:'/careerevalution/guide',query: { name:'znsp',part:'znsp31'}},
              imgName:'kongjian_danao.png',
              content:'空间-视觉能力是指大脑通过观察、触摸以及实践经验得到的一种能思考物体形状、位置的能力。例如我们在听一段语音导航时，大脑中便能呈现相应的图示或路线。空间能力可通过定向、心理旋转和美术测验等进行考查。如美术能力强的个体能够运用色彩、线条等表达出自己所想所思；对美有一定的鉴赏、辨析能力，适合从事设计类工作，甚至成为艺术家。',
            },
            znsp32:{
              title:'空间-视觉能力',
              url:{ path:'/careerevalution/guide',query: { name:'znsp',part:'znsp32'}},
              imgName:'kongjian_danao2.png',
              content:'空间-视觉能力是指大脑通过观察、触摸以及实践经验得到的一种能思考物体形状、位置的能力。例如我们在听一段语音导航时，大脑中便能呈现相应的图示或路线。空间能力可通过定向、心理旋转和美术测验等进行考查。如美术能力强的个体能够运用色彩、线条等表达出自己所想所思；对美有一定的鉴赏、辨析能力，适合从事设计类工作，甚至成为艺术家。',
            },
            znsp33:{
              title:'空间-视觉能力',
              url:{ path:'/careerevalution/guide',query: { name:'znsp',part:'znsp33'}},
              imgName:'kongjian_danao3.png',
              content:'空间-视觉能力是指大脑通过观察、触摸以及实践经验得到的一种能思考物体形状、位置的能力。例如我们在听一段语音导航时，大脑中便能呈现相应的图示或路线。空间能力可通过定向、心理旋转和美术测验等进行考查。如美术能力强的个体能够运用色彩、线条等表达出自己所想所思；对美有一定的鉴赏、辨析能力，适合从事设计类工作，甚至成为艺术家。',
            },
            znsp41:{
              title:'人际能力',
              url:{ path:'/careerevalution/guide',query: { name:'znsp',part:'znsp41'}},
              imgName:'renji_danao.png',
              content:'人际能力包括情绪识别与调节、人际情境判断与应对等能力，一定程度上反映个体的社会化发展程度和人际交往状况。人际能力强的个体一般具有如下表现：能够准确识别自己和他人的情绪信息；对人际互动或社会文化情境有合理的判断和评估；能够进行良好的人际互动，建立和谐的人际关系等。',
            },
            znsp42:{
              title:'人际能力',
              url:{ path:'/careerevalution/guide',query: { name:'znsp',part:'znsp42'}},
              imgName:'renji_danao.png',
              content:'人际能力包括情绪识别与调节、人际情境判断与应对等能力，一定程度上反映个体的社会化发展程度和人际交往状况。人际能力强的个体一般具有如下表现：能够准确识别自己和他人的情绪信息；对人际互动或社会文化情境有合理的判断和评估；能够进行良好的人际互动，建立和谐的人际关系等。',
            },
            znsp43:{
              title:'人际能力',
              url:{ path:'/careerevalution/guide',query: { name:'znsp',part:'znsp43'}},
              imgName:'renji_danao.png',
              content:'人际能力包括情绪识别与调节、人际情境判断与应对等能力，一定程度上反映个体的社会化发展程度和人际交往状况。人际能力强的个体一般具有如下表现：能够准确识别自己和他人的情绪信息；对人际互动或社会文化情境有合理的判断和评估；能够进行良好的人际互动，建立和谐的人际关系等。',
            },
            znsp51:{
              title:'数学-逻辑能力',
              url:{ path:'/careerevalution/guide',query: { name:'znsp',part:'znsp51'}},
              imgName:'shuxue_danao.png',
              content:'数学-逻辑能力包括进行数学运算与逻辑思考的能力， 如辨别、推理事物之间关系和规律的能力。数学能力强的个体，可能在学习数学等学科时更顺利，在进行自然科学研究、工程技术研究上也表现出一定的优势。',
            },
            znsp52:{
              title:'数学-逻辑能力',
              url:{ path:'/careerevalution/guide',query: { name:'znsp',part:'znsp52'}},
              imgName:'shuxue_danao2.png',
              content:'数学-逻辑能力包括进行数学运算与逻辑思考的能力， 如辨别、推理事物之间关系和规律的能力。数学能力强的个体，可能在学习数学等学科时更顺利，在进行自然科学研究、工程技术研究上也表现出一定的优势。',
            },
            znsp53:{
              title:'数学-逻辑能力',
              url:{ path:'/careerevalution/guide',query: { name:'znsp',part:'znsp53'}},
              imgName:'shuxue_danao3.png',
              content:'数学-逻辑能力包括进行数学运算与逻辑思考的能力， 如辨别、推理事物之间关系和规律的能力。数学能力强的个体，可能在学习数学等学科时更顺利，在进行自然科学研究、工程技术研究上也表现出一定的优势。',
            },
            znsp61:{
              title:'空间-视觉能力',
              url:{ path:'/careerevalution/guide',query: { name:'znsp',part:'znsp61'}},
              imgName:'kongjian_danao4.png',
              content:'空间-视觉能力是指大脑通过观察、触摸以及实践经验得到的一种能思考物体形状、位置的能力。例如我们在听一段语音导航时，大脑中便能呈现相应的图示或路线。空间能力可通过定向、心理旋转和美术测验等进行考查。如美术能力强的个体能够运用色彩、线条等表达出自己所想所思；对美有一定的鉴赏、辨析能力，适合从事设计类工作，甚至成为艺术家。',
            },
            znsp71:{
              title:'人际能力',
              url:{ path:'/careerevalution/guide',query: { name:'znsp',part:'znsp71'}},
              imgName:'renji_danao2.png',
              content:'人际能力包括情绪识别与调节、人际情境判断与应对等能力，一定程度上反映个体的社会化发展程度和人际交往状况。人际能力强的个体一般具有如下表现：能够准确识别自己和他人的情绪信息；对人际互动或社会文化情境有合理的判断和评估；能够进行良好的人际互动，建立和谐的人际关系等。',
            },
            znsp81:{
              title:'身体运动能力',
              url:{ path:'/careerevalution/guide',query: { name:'znsp',part:'znsp81'}},
              imgName:'yundong_danao.png',
              content:'身体运动能力包括动手操作能力，主要反映为动作 的灵活性和协调性。动手能力强的个体善于使用工具进行操作型的事务。本测试主要考查精细操作能力。',
            },
            znsp91:{
              title:'身体运动能力',
              url:{ path:'/careerevalution/guide',query: { name:'znsp',part:'znsp91'}},
              imgName:'yundong_danao2.png',
              content:'身体运动能力包括动手操作能力，主要反映为动作的灵活性和协调性。动手能力强的个体善于使用工具进行操作型的事务。本测试主要考查精细操作能力。',
            },
            znsp101:{
              title:'音乐能力',
              url:{ path:'/careerevalution/guide',query: { name:'znsp',part:'znsp101'}},
              imgName:'yinyue_danao.png',
              content:'音乐能力包括察觉、辨别和表达音乐的能力，表现 为对节奏、音调、音色等的敏感以及通过作曲、演奏、歌唱等形式来表达思想或情感。',
            },
          },
          xqqx:{
            main:{
              title:'兴趣倾向',
              url:{ path:'/careerevalution/guide',query: { name:'xqqx',part:'xqqx11'}},
              imgName:'xingqu_xingqu.png',
              content:'兴趣是个人对其环境中的人、事、物所产生的喜爱程度，是个人力求认识、掌握某事物，并经常参与该种活动的心理倾向。当个人对某事物有兴趣时，会对它产生特别的注意力。兴趣是人们活动的重要动力之一，是活动成功的重要条件。',
              leftHalfCss:{width:'450px'},
              bool:true,
              right:true
            }
          },
          zyjzg:{
              main:{
                title:'职业价值观',
                url:{ path:'/careerevalution/guide',query: { name:'zyjzg',part:'zyjzg11'}},
                imgName:'zhiye_zhiye.png',
                content:'职业价值观指的是人们在选择并发展自己的职业时所围绕的中心，是一个人哪怕是在不得不做出职业选择的时候，也无论如何都不愿意放弃的职业当中至关重要的东西或价值。职业和价值观的匹配度对人们的工作效率、满意度和稳定性有显著影响。',
                leftHalfCss:{width:'450px'},
                bool:true
              }
          },
          xlssx:{
              main:{
                title:'心理适应性',
                url:{ path:'/careerevalution/guide',query: { name:'xlssx',part:'xlssx11'}},
                imgName:'xinli_xinli.png',
                content:'心理适应性是一个人在各种环境中与环境做到最佳平衡的能力，是心理健康的标志之一。中学生的心理适应性可以通过其面临的内外压力程度来评估，压力适度可以提高动机和学习效率，压力过度则容易引发身心问题，不利于良性发展。',
                leftHalfCss:{width:'450px'},
                bool:true
              }
          }
        }
      }
    },
    methods:{
      go(url){
        if(url.path==this.$route.path){
          this.name=url.query.name
          this.part=url.query.part
        }
        this.$router.push(url)
      }
    }
  }
</script>

<style scoped lang="less">
.box{
  /* display: flex; */
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0 30px;
}

.left_half{
  width: 400px;
  vertical-align: top;
}
.left_half .title,.left_half .btn_warp2{
  text-align: center;

}
.left_half,.right_half{
  display: inline-block;
}
.left_half .title h4{
  color: #2FEEFF;
  font-size: 28px;
  margin-bottom: 15px;
}
.left_half .text_bewrite2 p{
  color: #fff;
  line-height: 26px;
  font-size: 16px;
  font-weight: 500;
  text-indent: 34px;
}
.left_half .btn_warp2 .button{
  width: 166px;
  height: 40px;
  background: linear-gradient(90deg, #1FD99C 0%, #1AC6FD 100%);
  border-radius: 20px;
  border: none;
  color: #fff;
  font-size: 18px;
  line-height: 40px;
  box-sizing: border-box;
  margin: 40px auto 0;
  cursor: pointer;
  &:hover{
    transform: scale(1.02);
  }
}
.right_half{
  width: 800px;
  margin-left: 100px;
}
</style>